import { getAdditionalUserInfo, getRentMortgageEstimate, getUser, getUserAddresses, getYearsAtBankEstimate, } from 'actions';
import { GET_YEARS_AT_BANK_ESTIMATE_SUCCESS } from 'actions/types';
import { seedMonevoOnboarding, setMonevoDetails, } from './reducers/monevoOnboarding';
import { selectMonevoMainBankAccount, selectMonevoSeedFromUser, } from './selectors';
export const prefetchMonevoData = async (dispatch, getState) => {
    dispatch(getUser());
    dispatch(getUserAddresses());
    /**
     * Awaited because the account the years-at-bank estimate is scoped to is
     * the one saved on the user.
     */
    await dispatch(getAdditionalUserInfo());
    dispatch(seedMonevoOnboarding(selectMonevoSeedFromUser(getState())));
    const accountId = selectMonevoMainBankAccount(getState())?.id;
    await Promise.all([
        (async () => {
            const result = await dispatch(getRentMortgageEstimate());
            const estimate = result?.payload?.rentMortgagePaymentEstimate;
            if (estimate == null)
                return;
            const rentalMortgagePayments = Math.round(estimate);
            dispatch(setMonevoDetails({
                rentMortgagePaymentEstimate: rentalMortgagePayments,
            }));
            // Prefills the answer, unless the user has already given their own.
            dispatch(seedMonevoOnboarding({ rentalMortgagePayments }));
        })(),
        (async () => {
            const result = await dispatch(getYearsAtBankEstimate(accountId));
            if (result?.type !== GET_YEARS_AT_BANK_ESTIMATE_SUCCESS)
                return;
            const estimate = result.payload.yearsAtBankEstimate;
            dispatch(setMonevoDetails({
                yearsAtBankEstimate: estimate ?? undefined,
                yearsAtBankEstimateAccountId: accountId,
            }));
            if (estimate != null) {
                dispatch(seedMonevoOnboarding({ timeAtBank: String(estimate) }));
            }
        })(),
    ]);
};
